import { useEffect, useState } from 'react';
import { EditButton, ListButton, TopToolbar, useResourceContext } from 'react-admin';
import { getCustomTableShow } from '../components/CustomTableShow';

const dataHandler = (fields, fieldName, fieldList, index) => {
    if (fieldName === 'password') {
        return true;
    }
};

const PostShowActions = () => (
    <TopToolbar>
        <ListButton />
        <EditButton />
    </TopToolbar>
);

const UserShow = (props) => {
    const resource = useResourceContext(props);
    const [data, setData] = useState();

    useEffect(() => {
        const propsToUse = {
            ...props,
            actions: <PostShowActions />
        };

        getCustomTableShow(resource, propsToUse, dataHandler).then((data) => setData(data));
    }, [ props, resource ]);

    if (data == null) {
        return <div></div>;
    }

    return data;
};

export default UserShow;
